import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import { Grid } from '@mui/material';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';

const ContractSummary = ({ t, leasingOfferContractData, contractSelected, modificationName }) => {
  return (
    <Grid container spacing={1}>
      <Grid item xs={6}>
        <strong>{t('RestructuringEdit.Contract.Summary.ModificationType')}:</strong>{' '}
        {contractSelected?.modificationTypeName || modificationName}
      </Grid>
      <Grid item xs={6}>
        <strong>{t('RestructuringEdit.Contract.Summary.Number')}:</strong>
        {leasingOfferContractData?.contractNumber ||
          contractSelected?.contractNumber ||
          (leasingOfferContractData?.isInitialState && <PriorityHighIcon fontSize='small' style={{ color: 'Red' }} />)}
      </Grid>
    </Grid>
  );
};

ContractSummary.propTypes = {
  t: PropTypes.func.isRequired,
  leasingOfferContractData: PropTypes.object.isRequired,
  contractSelected: PropTypes.object,
  modificationName: PropTypes.string
};

export default compose(withTranslation())(ContractSummary);
